module.exports = __webpack_public_path__ + "img/banner.2e99419a.png";